export const FETCH_SKIPPEDORDERS_REQUEST = "FETCH_SKIPPEDORDERS_REQUEST";
export const FETCH_SKIPPEDORDERS_SUCCESS = "FETCH_SKIPPEDORDERS_SUCCESS";
export const FETCH_SKIPPEDORDERS_FAILURE = "FETCH_SKIPPEDORDERS_FAILURE";
// export const UPDATE_AGENCY_SUCCESS = "UPDATE_AGENCY_SUCCESS";
// export const UPDATE_AGENCY_FAILURE = "UPDATE_AGENCY_FAILURE";
